import {
  typeOrderedFind,
  getChildLink,
  ChildType,
  getDistanceLinks,
} from './children';

export const getNavigationLinksAndLabels = ({
  searchParams,
  categoryData: { distanceChildren, parents, labels },
}) => {
  const distanceLinks = getDistanceLinks(distanceChildren, searchParams);
  const distanceLabel = typeOrderedFind(labels, [ChildType.DISTANCE]).value;
  const sportParentLinks =
    parents && parents.length
      ? parents
          // Do not include any location parents
          .filter(({ type }) => type === ChildType.DISTANCE)
          .map((parent) =>
            getChildLink(parent, ChildType.DISTANCE, searchParams),
          )
          // Ensure all parents have a text and a link
          .filter(({ text, link }) => !!text && !!link)
          // Do not show a parent if it is for the same sport as the current pages sport.
          // This is the case for category pages with a location.
          .filter(({ text }) => text !== distanceLabel)
          .reverse()
      : [];

  return { distanceLinks, distanceLabel, sportParentLinks };
};
